module.exports = __webpack_public_path__ + "img/06-oval-convex-1.6a88c986.svg";